<template>
    <v-card outlined class="pa-4">
        <v-card-title class="card-home-title">Projetos</v-card-title>
        
        <v-card-text>
            <v-tabs v-model="tab">
                <v-tab>Iniciaram hoje</v-tab>
                <v-tab>Iniciam amanhã</v-tab>
                <v-tab>Atrasados</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-list style="max-height: 300px; min-height: 300px;" two-line class="mt-2">
                        <v-list-item
                        v-for="project in startToday.data"
                        :key="project.projeto_id"
                        >
                            <v-list-item-content>
                            <v-list-item-title v-text="'#' + project.projeto_id + ' - ' +project.cliente.cli_nome_fantasia"></v-list-item-title>

                            <v-list-item-subtitle v-text="project.servico.servicoFullName" class="mt-2"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                            <v-btn :to="`/projeto/editar/${project.projeto_id}`" icon>
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-tab-item>

                <v-tab-item>
                    <v-list style="max-height: 300px; min-height: 300px;" two-line class="mt-2">
                        <v-list-item
                        v-for="project in startTomorrow.data"
                        :key="project.projeto_id"
                        >
                            <v-list-item-content>
                            <v-list-item-title v-text="'#' + project.projeto_id + ' - ' +project.cliente.cli_nome_fantasia"></v-list-item-title>

                            <v-list-item-subtitle v-text="project.servico.servicoFullName" class="mt-2"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                            <v-btn :to="`/projeto/editar/${project.projeto_id}`" icon>
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-tab-item>

                <v-tab-item>
                    <v-list style="max-height: 300px; min-height: 300px;" two-line class="mt-2">
                        <v-list-item
                        v-for="project in atrasados.data"
                        :key="project.projeto_id"
                        >
                            <v-list-item-content>
                            <v-list-item-title v-text="'#' + project.projeto_id + ' - ' +project.cliente.cli_nome_fantasia"></v-list-item-title>

                            <v-list-item-subtitle v-text="project.servico.servicoFullName" class="mt-2"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                            <v-btn :to="`/projeto/editar/${project.projeto_id}`" icon>
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</template>

<script>
import ProjetoService from '../../../services/ProjetoService'
export default {
    name: 'project-start-card',
    data: () => ({
        tab: null,
        startToday: [],
        startTomorrow: [],
        atrasados: []
    }),
    computed: {
        service () {
            return new ProjetoService;
        }
    },
    methods: {
        async getProjects() {
            this.startToday = await this.service.getAll({
                projeto_inicio: [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
                status: 'iniciado'
            })

            this.startTomorrow = await this.service.getAll({
                projeto_inicio: [
                    new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10), 
                    new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
                ],
                status: 'nao_iniciado'
            })

            this.atrasados = await this.service.getAll({
                status: 'atrasado'
            })
        }
    },
    created () {
        this.getProjects()
    }
}
</script>
